import {
	useDecisionMakerProfilePageData,
	useDecisionMakerProfilePageFcm,
	useDMProfilePagePaginatedTargetedPetitionsData,
} from 'src/app/pages/decisionMakerProfile/pageContext';
import { useDs2Experiment } from 'src/app/shared/hooks/ds2Experiment';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useTrackView } from 'src/app/shared/hooks/tracking';

import { useResponsivenessScoreEnabled } from '../useResponsivenessScoreEnabled';

type Result = ModelHookResult<{
	showSapContainer: boolean;
}>;

export function useLayout(): Result {
	const sourceLocation = useQueryParamValue('source_location');
	const { id, type, verifiedAt } = useDecisionMakerProfilePageData();
	const {
		dmProfileRedesign: {
			profileCard: profileRedesignEnabled,
			targetedPetitionList: petitionsRedesignEnabled,
			sapToDm: sapToDmRedesignEnabled,
		},
	} = useDecisionMakerProfilePageFcm();
	const { fcmEnabled: ds2Enabled } = useDs2Experiment();

	const {
		data: { totalCount: petitionCount },
	} = useDMProfilePagePaginatedTargetedPetitionsData();

	const responsivenessScoreEnabled = useResponsivenessScoreEnabled();

	useTrackView(
		'dm_show_view',
		{
			dm_id: `dm_${id}`,
			dm_verified: !!verifiedAt,
			dm_type: type,
			dm_petitions_num: petitionCount,
			source_location: sourceLocation,
			dm_responsiveness_score_enabled: responsivenessScoreEnabled,
		},
		[],
	);

	const shownInPetitionListRedesign = petitionCount === 1 && petitionsRedesignEnabled;
	const showSapContainer =
		!shownInPetitionListRedesign && ds2Enabled && (sapToDmRedesignEnabled || profileRedesignEnabled);

	return {
		data: { showSapContainer },
	};
}
